(function () {
  const wrappers = document.querySelectorAll('[data-banner-login-form]');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const blockId = wrapper.dataset.bannerLoginForm;
    const flagKey = 'bannerLoginSuccess-' + blockId;
    const successEl = wrapper.querySelector('[data-banner-login-success]');
    const items = wrapper.querySelectorAll('[data-account-popup-item]');
    const forms = wrapper.querySelectorAll('form');

    // On page load: if a previous submit set the flag and the rendered form has
    // no errors (i.e. submission actually succeeded), hide the form items and
    // reveal the success message. Always consume the flag so a stale value
    // doesn't trigger again on a later visit.
    if (sessionStorage.getItem(flagKey)) {
      sessionStorage.removeItem(flagKey);
      const hasErrors = wrapper.querySelector('[aria-invalid="true"]');
      if (successEl && !hasErrors) {
        items.forEach((it) => it.classList.add('hidden'));
        wrapper.classList.remove('hidden');
        successEl.classList.remove('hidden');
      }
    }

    // Set the flag right before submit so the post-redirect render shows the
    // success message. If the submission fails server-side, the flag will be
    // consumed on the next page load without showing the message (because
    // aria-invalid will be present).
    forms.forEach((f) => {
      f.addEventListener('submit', () => {
        sessionStorage.setItem(flagKey, '1');
      });
    });
  });
})();
